import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { default as dayjsIsToday } from 'dayjs/plugin/isToday';
import 'dayjs/locale/es';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { operators } from "../components/Filters/operators";
const {
  TODAY,
  YESTERDAY,
  TOMORROW,
  THIS_WEEK,
  LAST_WEEK,
  NEXT_WEEK,
  THIS_MONTH,
  LAST_MONTH,
  NEXT_MONTH,
  THIS_QUARTER,
  LAST_QUARTER,
  NEXT_QUARTER,
  THIS_YEAR,
  LAST_YEAR,
  NEXT_YEAR
} = operators;
dayjs.locale('es');
dayjs.extend(quarterOfYear);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(dayjsIsToday);
dayjs.extend(customParseFormat);
export const getRange = range => {
  const {
    unit,
    offset
  } = {
    [TODAY]: {
      unit: 'd',
      offset: 0
    },
    [YESTERDAY]: {
      unit: 'd',
      offset: 1
    },
    [TOMORROW]: {
      unit: 'd',
      offset: 1
    },
    [THIS_WEEK]: {
      unit: 'w',
      offset: 0
    },
    [LAST_WEEK]: {
      unit: 'w',
      offset: 1
    },
    [NEXT_WEEK]: {
      unit: 'w',
      offset: 1
    },
    [THIS_MONTH]: {
      unit: 'M',
      offset: 0
    },
    [LAST_MONTH]: {
      unit: 'M',
      offset: 1
    },
    [NEXT_MONTH]: {
      unit: 'M',
      offset: 1
    },
    [THIS_QUARTER]: {
      unit: 'Q',
      offset: 0
    },
    [LAST_QUARTER]: {
      unit: 'Q',
      offset: 1
    },
    [NEXT_QUARTER]: {
      unit: 'Q',
      offset: 1
    },
    [THIS_YEAR]: {
      unit: 'y',
      offset: 0
    },
    [LAST_YEAR]: {
      unit: 'y',
      offset: 1
    },
    [NEXT_YEAR]: {
      unit: 'y',
      offset: 1
    }
  }[range];
  const action = [TOMORROW, NEXT_WEEK, NEXT_MONTH, NEXT_QUARTER, NEXT_YEAR].includes(range) ? 'add' : 'subtract';
  const moment = dayjs()[action](offset, unit);
  return [new Date(moment.startOf(unit)), new Date(moment.endOf(unit))];
};
export const formatDate = _ref => {
  let {
    dateString,
    format = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
    UTC = true
  } = _ref;
  let moment = dayjs(dateString);
  if (UTC) moment = moment.utc();
  return moment.format(format);
};
export const composeDateTime = _ref2 => {
  let {
    dateString,
    timeString
  } = _ref2;
  let date = dayjs(dateString);
  const [hours, minutes] = timeString.split(':').map(Number);
  date = date.hour(hours).minute(minutes);
  return date;
};
export const getNewUTCDate = function (format) {
  if (format === void 0) {
    format = 'DD/MM/YYYY HH:mm:ss';
  }
  const nowUTC = dayjs().utc().format(format);
  return nowUTC;
};
export const isToday = date => {
  return dayjs(date).isToday();
};
export const isSame = function (date1, date2, name) {
  if (name === void 0) {
    name = 'year';
  }
  if (date2) return dayjs(date2).isSame(date1, name);
  return dayjs().isSame(date1, name);
};
export const getMomentFromDateBackend = function (dateString, inputFormat, isUTC) {
  if (inputFormat === void 0) {
    inputFormat = 'DD/MM/YYYY HH:mm:ss';
  }
  if (isUTC === void 0) {
    isUTC = false;
  }
  let moment = dayjs(dateString, inputFormat);
  if (isUTC) moment = dayjs.utc(dateString, inputFormat);
  return moment;
};
export const getDateToUserTimezone = _ref3 => {
  let {
    date,
    inputFormat = 'DD/MM/YYYY HH:mm:ss',
    outputFormat = 'DD/MM/YYYY HH:mm:ss'
  } = _ref3;
  const moment = dayjs.isDayjs(date) ? date : dayjs(date, inputFormat);
  const timezone = dayjs.tz.guess();
  return moment.tz(timezone).format(outputFormat);
};
export const getRangeFromTodayToYearAgo = () => {
  const moment = dayjs();
  return [new Date(moment.startOf('d').subtract(1, 'year')), new Date(moment.endOf('d'))];
};